import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { curSym as sym } from "@/lib/currency";

const FILTERS = [["all", "Toutes"], ["pending", "À payer"], ["paid", "Payées"], ["credit", "Avoirs"]];
const ST = {
  pending: ["À payer", "bg-amber-100 text-amber-700"],
  paid: ["Payée", "bg-emerald-600 text-white"],
  refund_pending: ["Avoir à rembourser", "bg-red-100 text-red-700"],
  refunded: ["Remboursée", "bg-secondary text-primary"],
  cancelled: ["Annulée", "bg-muted text-muted-foreground"],
};

// Vue FACTURES (Finance) : Toutes / À payer / Payées / Avoirs — réutilise db.invoices existante.
export const AdminInvoices = () => {
  const [invs, setInvs] = useState([]);
  const [f, setF] = useState("all");
  useEffect(() => { api.get("/admin/invoices").then(({ data }) => setInvs(data)).catch(() => {}); }, []);
  const rows = invs.filter((i) =>
    f === "all" ? true
      : f === "pending" ? i.status === "pending"
      : f === "paid" ? i.status === "paid"
      : ["credit"].includes(i.type) || ["refund_pending", "refunded"].includes(i.status));
  const count = (k) => invs.filter((i) =>
    k === "all" ? true : k === "pending" ? i.status === "pending"
      : k === "paid" ? i.status === "paid"
      : ["credit"].includes(i.type) || ["refund_pending", "refunded"].includes(i.status)).length;

  return (
    <div className="mb-6" data-testid="invoices-panel">
      <h3 className="font-heading font-bold">Factures</h3>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {FILTERS.map(([v, l]) => (
          <button key={v} data-testid={`inv-filter-${v}`} onClick={() => setF(v)}
            className={`px-3 py-1 text-xs font-semibold border transition-colors ${f === v ? "bg-primary text-white border-primary" : "border-border hover:border-accent"}`}>
            {l} ({count(v)})
          </button>
        ))}
      </div>
      <div className="mt-2 border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-3 py-2">N° facture</th><th className="px-3 py-2">Client</th>
              <th className="px-3 py-2">Montant</th><th className="px-3 py-2">Statut</th>
              <th className="px-3 py-2">Date</th><th className="px-3 py-2 text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.slice(0, 100).map((i) => {
              const [lbl, cls] = ST[i.status] || [i.status, "bg-secondary"];
              return (
                <tr key={i.id} data-testid={`inv-row-${i.id}`} className="border-b border-border last:border-0">
                  <td className="px-3 py-2 font-mono font-semibold">{i.number}{i.type === "adjustment" && <span className="ml-1 text-[10px] text-amber-700">complément</span>}{i.type === "credit" && <span className="ml-1 text-[10px] text-red-700">avoir</span>}</td>
                  <td className="px-3 py-2">{i.customer_name || "—"}<div className="text-[10px] text-muted-foreground font-mono">{i.reference}</div></td>
                  <td className="px-3 py-2 font-bold whitespace-nowrap">{sym(i.currency)}{Number(i.amount).toFixed(2)}</td>
                  <td className="px-3 py-2"><Badge className={`rounded-sm ${cls}`}>{lbl}</Badge></td>
                  <td className="px-3 py-2 text-xs text-muted-foreground whitespace-nowrap">{(i.created_at || "").slice(0, 10)}</td>
                  <td className="px-3 py-2 text-right">
                    {i.shipment_id && (
                      <Button asChild size="sm" variant="outline" className="rounded-sm h-7 text-xs" data-testid={`inv-view-${i.id}`}>
                        <Link to={`/shipments/${i.shipment_id}`}>Voir</Link>
                      </Button>
                    )}
                  </td>
                </tr>
              );
            })}
            {rows.length === 0 && <tr><td colSpan={6} className="px-3 py-6 text-center text-muted-foreground">Aucune facture.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
